export const DataEntryMenu = [
  {
    title: "Raise Complaints",
    iconStyle: imagepaths.complaintsIcon,
    iconActive: imagepaths.complaintsIconActive,
    to: "/app/raisecomplaints",
    id: "raisecomplaints",
  },
]